import { Navigate } from 'react-router-dom';

import { PERMISSION } from 'src/features/auth/types';
import { PATH } from 'src/features/navigation/utils/constants';
import useHasPermissions from 'src/hooks/useHasPermissions';

type Permission = {
    hasPermission: boolean;
    redirectPath: string | Partial<Location>;
};
export type PermissionRedirect = {
    [key: string]: Permission;
};

const HomeRedirect = () => {
    const accessVisitorsModule = useHasPermissions(
        [
            PERMISSION.ACCESS_ACTIVE_STAYS,
            PERMISSION.ACCESS_PAST_STAYS,
            PERMISSION.ACCESS_VISITORS,
            PERMISSION.ACCESS_GATEWAY_PASSES,
            PERMISSION.ACCESS_EVENT_LOGS,
        ],
        true,
    );

    const accessMonitoring = useHasPermissions(
        [
            PERMISSION.ACCESS_PAY_STATIONS_MONITORING,
            PERMISSION.ACCESS_DEVICES_MONITORING,
            PERMISSION.ACCESS_GATEWAYS_MONITORING,
        ],
        true,
    );

    const accessPayments = useHasPermissions(
        [
            PERMISSION.ACCESS_PAYMENTS,
            PERMISSION.ACCESS_PAY_STATIONS,
            PERMISSION.ACCESS_PAY_STATION_OPERATIONS,
            PERMISSION.ACCESS_PAY_STATION_EVENTS,
        ],
        true,
    );

    const accessStatistics = useHasPermissions(
        [PERMISSION.ACCESS_PAYMENT_STATISTICS, PERMISSION.ACCESS_OCCUPANCY_STATISTICS],
        true,
    );

    const permissionsForRedirect: PermissionRedirect[] = [
        {
            [PATH.VISITORS]: {
                hasPermission: accessVisitorsModule,
                redirectPath: `/${PATH.VISITORS}/*`,
            },
        },
        {
            [PATH.MEMBERSHIPS]: {
                hasPermission: useHasPermissions([PERMISSION.ACCESS_MEMBERSHIPS]),
                redirectPath: `/${PATH.MEMBERSHIPS}`,
            },
        },
        {
            [PATH.ENTITIES]: {
                hasPermission: useHasPermissions([PERMISSION.ACCESS_ENTITIES]),
                redirectPath: `/${PATH.ENTITIES}/*`,
            },
        },
        {
            [PATH.MONITORING]: {
                hasPermission: accessMonitoring,
                redirectPath: `/${PATH.MONITORING}/*`,
            },
        },
        {
            [PATH.PAYMENTS]: {
                hasPermission: accessPayments,
                redirectPath: `/${PATH.PAYMENTS}/*`,
            },
        },
        {
            [PATH.STATISTICS]: {
                hasPermission: accessStatistics,
                redirectPath: `/${PATH.STATISTICS}/*`,
            },
        },
        {
            [PATH.PROFILE]: {
                hasPermission: true,
                redirectPath: `/${PATH.PROFILE}`,
            },
        },
        {
            [PATH.ADMINISTRATION]: {
                hasPermission: useHasPermissions([PERMISSION.MANAGE_SYSTEM_SETTINGS]),
                redirectPath: `/${PATH.ADMINISTRATION}/*`,
            },
        },
    ];

    const firstAllowed = permissionsForRedirect.find((permission) => {
        const key = Object.keys(permission)[0];
        return permission[key].hasPermission;
    });

    if (firstAllowed) {
        const key = Object.keys(firstAllowed)[0];
        const { redirectPath } = firstAllowed[key];
        return <Navigate to={redirectPath} key={key} />;
    }

    return null;
};

export default HomeRedirect;
